import { Panel } from "primereact/panel";
import { TextField } from "../../../components/TextField";
import { useTranslation } from "react-i18next";


 
 
 
export const Pgfn = ({pgfn}: {pgfn: any}) => {
  const { t } = useTranslation();
  const getValue = (value?: string): string => value || "Não informado";
  const result = pgfn.data[0]
  return (
    <div>
      <Panel header={result.mensagem}>
        {pgfn.erro ? (<p>{pgfn.erro}</p>):(<div>
        
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Documento"
                value={getValue(result.cpf ? result.cpf : result.cnpj)}
              />
             <TextField
                label="Comprovante"
                value={getValue(result.consulta_comprovante)}
              />
             <TextField
                label="Débitos "
              value={getValue(result.debitos_pgfn ? 'Sim' : 'Não')}
              />
            <TextField
                label="Tipo"
                value={getValue(result.tipo)}
              />
            <TextField
                label="Observação"
                value={getValue(result.observacoes)}
              />
            <TextField
                label="Certidão"
                value={<a download={result.consulta_comprovante+'.pdf'}  href={'data:application/octet-stream;base64,'+result.site_receipt}>download</a>}
              />
            </div>
            <div>
              <TextField
                label="Nome"
                value={getValue(result?.nome)}
              />
              <TextField
                label="Data Consulta"
                value={getValue(result.consulta_datahora)}
              />
               <TextField
                    label="Débitos Receita Federal"
                    value={getValue(result.debitos_rfb ? 'Sim' : 'Não')}/>
                <TextField
                    label="Data emissão"
                    value={getValue(result.emissao_data)}
                />
                <TextField
                    label="Data validade"
                    value={getValue(result.validade_data)}
                />
            </div>
          </section>
        </div>)} 
      </Panel>
      
    </div>
  );
};